export { default } from './PartitionPermissionsPage.vue'
